import React from "react";
import { useLocation } from "react-router";
import { SupplierDetail } from "../../Services/e-pro/models/SupplierModel";
import { GetSellerById } from "../../Services/e-pro/EcatalogService";
import { SellerType } from "../ScreenRedcross/DefaultEproModel";
import RegisterLegalEntityScreen from "../RegisterWolfScreen/RegisterLegalEntityScreen";
import RegisterIndividualScreen from "../RegisterWolfScreen/RegisterIndividualScreen";
import { MapSellerTypeToValiable } from "../../utils/redcross/map";
import LayoutBase from "../RegisterWolfScreen/LayoutBase";

export type DataAndPermission = {
  isSeller: boolean;
  isAuthenticated: boolean | undefined;
  isAdmin: boolean;
};
const SupplierListDetail = () => {
  const { search } = useLocation();
  const query = React.useMemo(() => new URLSearchParams(search), [search]);
  const [supplierDetail, setSupplierDetail] = React.useState<SupplierDetail>();

  React.useEffect(() => {
    getSellerById();
  }, [query]);

  const getSellerById = async () => {
    const sellerId = query.get("SellerID");
    const res = await GetSellerById(Number(sellerId));
    console.log("res = ", res);
    setSupplierDetail(res.data);
  };

  const isLegal =
    MapSellerTypeToValiable[supplierDetail?.SellerType!] ==
    SellerType.LegalEntity.toString();

  return (
    <LayoutBase sideMenu={<></>}>
      {isLegal ? (
        <RegisterLegalEntityScreen sellerDetail={supplierDetail} />
      ) : (
        <RegisterIndividualScreen sellerDetail={supplierDetail} />
      )}
    </LayoutBase>
  );
};

export default SupplierListDetail;
